export default __webpack_public_path__ + "557285cc7fff5bde0d6a0bcb8b1440fe.svg";